"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.GoogleSearchConsolePlugin = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _react = _interopRequireDefault(require("react"));

var GoogleSearchConsolePlugin =
/*#__PURE__*/
function (_React$Component) {
  (0, _inherits2["default"])(GoogleSearchConsolePlugin, _React$Component);

  function GoogleSearchConsolePlugin() {
    (0, _classCallCheck2["default"])(this, GoogleSearchConsolePlugin);
    return (0, _possibleConstructorReturn2["default"])(this, (0, _getPrototypeOf2["default"])(GoogleSearchConsolePlugin).apply(this, arguments));
  }

  (0, _createClass2["default"])(GoogleSearchConsolePlugin, [{
    key: "render",
    value: function render() {
      var config = this.props.config;
      return _react["default"].createElement(_react["default"].Fragment, null, _react["default"].createElement("meta", {
        name: "google-site-verification",
        content: config.GOOGLE_SEARCH_CONSOLE_VERIFICATION_ID
      }));
    }
  }]);
  return GoogleSearchConsolePlugin;
}(_react["default"].Component);

exports.GoogleSearchConsolePlugin = GoogleSearchConsolePlugin;